module.exports = __webpack_public_path__ + "images/179_4096.jpg";